import * as d3 from 'd3';

const Brushchart = function (opts) {
	
	this.selection = opts.selection; //must be d3.select object.
	this.aspectRatio = [960, 500];
	this.defaultColors = ["red", "blue", "green", "orange", "pink"] ;
	this.data = opts.data || {}
	
	console.log(this.data);
	
	
	
	this.lineChangeTransitionDuration = 300;
	
	this.margin = {top: 20, right: 20, bottom: 130, left: 40},
	this.margin2 = {top: 420, right: 20, bottom: 180, left: 40},
	//this.width and height here is the area of the main chart area (not inluding legends or anything else)
	this.width = this.aspectRatio[0] - this.margin.left - this.margin.right,
	this.height = this.aspectRatio[1] - this.margin.top - this.margin.bottom,
	this.height2 = 650 - this.margin2.top - this.margin2.bottom;
	
	
	//these variables set the starting width of the brush. Later changed by moving it.
	//this.brushContext sets the persistent storage of the variable
	this.startzoom = 1;
	this.brushContext = [this.width * (1 - this.startzoom), this.width];

	this.parseDate = d3.timeParse("%Y-%m-%dT%H:%M:%SZ");
	
	this.x = d3.scaleTime().range([0, this.width]);
	this.x2 = d3.scaleTime().range([0, this.width]);
	this.y = d3.scaleLinear().range([this.height, 0]);
	this.y2 = d3.scaleLinear().range([this.height2, 0]);
	
	
	this.buildSVG();
	this.calculateDomain();
	
	//draw axes before lines
	this.drawContextAxes();
	this.drawFocusAxes();
	
	//draw lines
	this.drawFocus();
	this.drawContext();
	
	//put the brush on and fit brush to Focus
	this.appendBrushToContext();
	
	
	this.overlayTooltip();
	
	
}

Brushchart.prototype.buildSVG = function () {
	const _t = this;
	
	_t.svg = _t.selection
			.append("svg")
			.attr("preserveAspectRatio", "xMinYMin meet")
			.attr("viewBox", "0 0 " + _t.aspectRatio[0] + " " + _t.aspectRatio[1])
			.classed("svg-content", true);
	
	_t.brush = d3.brushX()
			.extent([[0, 0], [_t.width, _t.height2]])
			.on("brush end", () => _t.brushed(_t)); //make sure to pass context!

	_t.zoom = d3.zoom()
			.scaleExtent([1, 8])  //bring extent down a bit to avoid too much nitty gritty
			.translateExtent([[0, 0], [_t.width, _t.height]])
			.extent([[0, 0], [_t.width, _t.height]])
			.on("zoom", _t.zoomed);
	
	//main chart
	_t.focusLine = d3.line()
			.curve(d3.curveMonotoneX)
			.x(function (d) {
				return _t.x(d.date);
			})
			.y(function (d) {
				return _t.y(d.value);
			})
			//null values do not appear
			.defined(function (d) {
				return (d.value != null)
			});
	
	//reference chart at the bottom
	_t.contextLine = d3.line()
			.curve(d3.curveMonotoneX)
			.x(function (d) {
				return _t.x2(d.date);
			})
			.y(function (d) {
				return _t.y2(d.value);
			})
			.defined(function (d) {
				return (d.value != null)
			})
	
	_t.svg.append("defs").append("clipPath")
			.attr("id", "clip")
			.append("rect")
			.attr("width", _t.width)
			.attr("height", _t.height);
	
	_t.focus = _t.svg.append("g")
			.attr("class", "focus")
			.attr("transform", "translate(" + (_t.margin.left) + "," + _t.margin.top + ")");
	
	_t.context = _t.svg.append("g")
			.attr("class", "context")
			.attr("transform", "translate(" + _t.margin2.left + "," + _t.margin2.top + ")");
	
	
}

Brushchart.prototype.appendBrushToContext = function () {
	
	const _t = this;
	
	_t.brushElement = _t.context.append("g")
			.attr("class", "brush")
			
	_t.brushElement
			.call(_t.brush)
			.call(_t.brush.move, _t.brushContext);
	
}

Brushchart.prototype.resetBrushContext = function (brushContext = this.brushContext) {
	const _t = this;
	
	_t.brushElement
			.call(_t.brush)
			.call(_t.brush.move, brushContext);
}

Brushchart.prototype.prepData = function () {
	const _t = this;
	
	//turn labels into datetime values.
	//we create a new "date" key in each record. This is what we use to make the scale!
	_t.data.forEach(g => {
		g.data.forEach(d => {
			d.date = _t.parseDate(d.label);
		})
	})
}

Brushchart.prototype.calculateDomain = function () {
	
	const _t = this;
	
	//prep data so we can calculate domain and get it ready to show.
	_t.prepData();
	
	/*
	We receive the data as a list of dictionaries, and so we loop over those dictionaries, pull the out the data array,
	and merge them all so we can determine a min/max range for both axes.
	 */
	
	// TODO: Determine whether any of the values is a percentage. If it is, set up a second axis.
	
	//const X_DOMAIN_EXTENT_PADDING = .1; //value that pads the decimals
	let mergedDataArrays = []
	
	_t.data.forEach(d => {
		mergedDataArrays = mergedDataArrays.concat(d.data);
	})
	
	
	const xdomain = d3.extent(mergedDataArrays.map(d => d.date));
	let ydomain = d3.extent(mergedDataArrays.map(d => d.value));
	
	//increase the domain in focus so that we don't come up against the edge of the chart
	const paddingFactor = ydomain[1] * .05
	
	ydomain = [ydomain[0] - paddingFactor > 0 ? ydomain[0] - paddingFactor : 0, ydomain[1] + paddingFactor]
	
	_t.x.domain(xdomain);
	_t.y.domain(ydomain);
	
	_t.x2.domain(xdomain);
	_t.y2.domain(ydomain);
	
	
}

//enforceTransition lets us know when we should and should not transition.
Brushchart.prototype.drawFocus = function (enforceTransition = true) {
	
	const _t = this;
	
	_t.focusLines = _t.focus.selectAll(".brushline")
			.data(_t.data, d => d.groupName);
	
	if (enforceTransition) {
		_t.focusLines
				.transition()
				.duration(_t.lineChangeTransitionDuration + 300)
				.attr("d", d => _t.focusLine(d.data))

		//reset brush Content to full width. brush Element is null on first draw.
		if (_t.brushElement) {
			_t.brushContext = _t.x2.range();
			 //set to max width, required for animation.
			setTimeout(() => _t.resetBrushContext(), _t.lineChangeTransitionDuration + 320)
		}
		
	} else {
		//just change the line
		_t.focusLines
			.attr("d", d => _t.focusLine(d.data))
	}
	
	_t.focusLines.exit()
			.attr('opacity', 1)
			.transition()
			.duration(_t.lineChangeTransitionDuration)
			.attr('opacity', 0)
			.remove();
	
	
	const newFocusLines = _t.focusLines
			.enter()
			.append("path")
			.attr('class', 'brushline line enter-path')
			.attr('clip-path', 'url(#clip)')
			.style('fill', 'none')
			.attr("d", d => _t.focusLine(d.data))
	
			
	
	

	const newPaths = d3.selectAll(".enter-path")

	//animate the entry drawing.
	newPaths.each(function (d, i) {
		//select the current path we are iterating over
		const _path = d3.select(newPaths.nodes()[i])

		var totalLength = _path.node().getTotalLength();

		_path.attr("stroke-dasharray", totalLength + " " + totalLength)
				.attr("stroke-dashoffset", totalLength)
				.transition()
				.duration(1100)
				.delay(200)
				.ease(d3.easeExpOut) //Try linear, quad, bounce... see other examples here - http://bl.ocks.org/hunzy/9929724
				.attr("stroke-dashoffset", 0)
				.style("stroke-width", 2)
	})

	//remove class the triggers animation so it does not retrigger on brush. But only after animation runs!
	setTimeout(() => {
		newFocusLines.classed('enter-path', false)
		.attr("stroke-dasharray", null) //need to remove this, otherwise lines will not grow to fill space on brush or next transition
		}, 1400);
	
	_t.focusLines.merge(newFocusLines)
			.style('stroke-width', 2)
			.style('stroke', (d, i) => d.color || _t.defaultColors[i])
	
	//ensure we brush! The transitions will want to force to full screen
	//_t.context.select(".brush").call(_t.brush.move, _t.brushContext);
	
	
}

Brushchart.prototype.drawContext = function () {
	
	const _t = this;
	
	_t.contextLines = _t.context.selectAll(".brushline-context")
			.data(_t.data, d => d.groupName)
	
	
	_t.contextLines.exit().remove();
	
	var newcontextLines = _t.contextLines
			.enter()
			.append("path")
			.attr('class', 'brushline-context line')
			.style('fill', 'none');
	
	_t.contextLines.merge(newcontextLines)
			.attr("d", function (d) {
				return _t.contextLine(d.data)
			})
			.style('stroke', (d, i) => d.color || _t.defaultColors[i])
	
	//remove unmatched data
	
}; //end draw

Brushchart.prototype.drawFocusAxes = function () {
	const _t = this;
	
	_t.xAxis = d3.axisBottom(_t.x);
	_t.yAxis = d3.axisLeft(_t.y).tickSizeInner(-_t.width);
	
	
	_t.focus.append("g")
			.attr("class", "axis axis--x")
			.attr('opacity', ".4")
			.attr("transform", "translate(0," + _t.height + ")")
			.call(_t.xAxis);
	
	_t.focus.append("g")
			.attr("class", "axis axis--y")
			.attr('opacity', ".4")
			.call(_t.yAxis);
}

Brushchart.prototype.drawContextAxes = function () {
	const _t = this;
	
	_t.xAxis2 = d3.axisBottom(_t.x2);
	
	//y axis is a single line at the bottom
	_t.yAxis2 = d3.axisLeft(_t.y2)
			.tickValues([_t.y2.domain()[0]])
			.tickSizeInner(-_t.width);
	
	
	_t.context.append("g")
			.attr("class", "axis axis--x")
			.attr("transform", "translate(0," + (_t.height2) + ")")
			.attr('opacity', ".4")
			.call(_t.xAxis2);
	
	
	const contextY = _t.context.append("g")
			.attr("class", "axis axis--y")
			.attr('opacity', ".4")
			.call(_t.yAxis2)
	
	//make the tick value invisible -- it is irrelevant
	contextY.select('.tick text').attr('opacity', 0);
	
}

Brushchart.prototype.updateAxes = function () {
	const _t = this;
	
	//transition focus axis
	_t.focus.select(".axis--y")
			.transition()
			.duration(this.lineChangeTransitionDuration)
			.call(_t.yAxis);
	
	//no transition for context axis
	_t.context.select(".axis--y")
			.transition()
			.duration(this.lineChangeTransitionDuration)
			.call(_t.yAxis2);
	
	
};


Brushchart.prototype.overlayTooltip = function() {
	
	const _t = this;
	
	///need to replace _t.data with a tooltip data variable
	//that variable will have a text date displayed on hover so we can show the date on the top of the line.

	_t.mouseGroup = _t.svg.append("g")
	.attr("class", "mouse-over-effects")
	.attr('transform', "translate(40,20)"); // inspect this translation later

	_t.mouseGroup.append("defs").append("clipPath")
			.attr("id", "clip")
			.append("rect")
			.attr("width", _t.width)
			.attr("height", _t.height);

		_t.mouseGroup.append("path") // this is the vertical line to follow mouse
		.attr("class", "mouse-line")
		.style("stroke-width", "1px")
		.style("stroke", "#375A8B")
		.style("opacity", "0");
		
		
		const hoverXLabel = _t.mouseGroup
				.append("g")
				.classed('xLabel', true)
				.attr('opacity', 1)
				.append('text')
				.classed('x-label-hover-text', true)
				.attr("text-anchor", "center")
				.attr("opacity", 0)
				

		const lines = document.getElementsByClassName('brushline');

		_t.mousePerLine = _t.mouseGroup.selectAll('.mouse-per-line')
		.data(_t.data).enter()
		.append("g")
		.attr("class", "mouse-per-line");


		_t.mousePerLine.append("circle")
			.classed("hovercircle", true)
		.attr("r", 7)
		.style("stroke", "#375A8B")
		.style("fill", "none")
		.style("stroke-width", "1px")
		// .style("opacity", "0");

		_t.mousePerLine.append("text")
		.classed('toplinetext', true)
		.attr("transform", "translate(10,3)")
		.attr('show', 1);

		
		
		

		_t.mouseGroup.append('svg:rect') // append a rect to catch mouse movements on canvas
			.attr('width', _t.width) // can't catch mouse events on a g element
			.attr('height', _t.height)
			.attr('fill', 'none')
			.attr('pointer-events', 'all')
			//.call(zoom) //ZOOM FUNCTION IS CALLED HERE!
			.on('mouseout', function() { // on mouse out hide line, circles and text
				_t.selection.selectAll(".mouse-line")
				.style("opacity", "0");
				_t.selection.selectAll(".mouse-per-line .hovercircle")
				.style("opacity", "0");
				_t.selection.selectAll(".mouse-per-line text")
				.style("opacity", "0");
				_t.selection.selectAll(".x-label-hover-text")
				.style("opacity", "0");
			})
			.on('mouseover', function() { // on mouse in show line, circles and text
				_t.selection.selectAll(".mouse-line")
				.style("opacity", .5);
				_t.selection.selectAll(".mouse-per-line .hovercircle")
				.style("opacity", .7);
				_t.selection.selectAll(".mouse-per-line text")
				.style("opacity", 1);
				_t.selection.selectAll(".x-label-hover-text")
				.style("opacity", 1);
			})
				.on('mousemove', function () { // mouse moving over canvas
					var mouse = d3.mouse(this);
					
					
					_t.selection.selectAll(".mouse-per-line")
							.attr("transform", function (d, i) {
								try {
									var xDate = _t.x.invert(mouse[0]),
											bisect = d3.bisector(function (d) {
												return d.date;
											}).right,
											idx = bisect(d.data, xDate); //not working remove this later
									
									var xpos = _t.x(_t.data[i].data[idx]['date']),
											ypos = _t.y(_t.data[i].data[idx]['value']);
								} catch (e) {
									console.error(e);
								}
								
								_t.selection.select(".mouse-line")
										.attr("d", function () {
											var d = "M" + xpos + "," + (_t.height+20);
											d += " " + xpos + "," + 0;
											return d;
										});
								
								var datedisplay = dateval => {
									const format = d3.timeFormat("%b %d %Hh");
									const dayformat = d3.timeFormat("%b %d");
									const datestring = format(dateval)
									return datestring.slice(7, 9) === "00" ? dayformat(dateval) : datestring
								}
								
								d3.select('.x-label-hover-text')
										.text(datedisplay(_t.data[i].data[idx]['date']))
										.attr("transform", "translate(" + (xpos-20) + "," + 384 + ")");
								
								var textelems = [_t.data[i].data[idx]['value'], datedisplay(_t.data[i].data[idx]['date'])];
								
								d3.select(this).selectAll('text').each(function (d, i) {
									d3.select(this).text(textelems[i]);
								});
								
								return "translate(" + xpos + "," + ypos + ")";
							});
				});


				///this is the rectangle that actually gets zoomed in and out.
	// mouseG.append("rect")
	// .attr("class", "zoom")
	// .attr("width", width)
	// .attr("height", height)
	// .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
	// .call(zoom);

};









// because the .call function passes in only the immediate parent as context, _t is not what we think it is.
// I therefore pass in the chartContext as a parameter (in the declaration of _t.brush), which ensures that _t is the BrushChart instance.

Brushchart.prototype.brushed = function (chartContext) {
	
	const _t = chartContext;
	
	if (d3.event.sourceEvent && d3.event.sourceEvent.type === "zoom") return; // ignore brush-by-zoom
	const s = d3.event.selection || _t.x2.range(); //this is either the biggest it will be, or the part that is zoomed in.
	_t.x.domain(s.map(_t.x2.invert, _t.x2));
	_t.brushContext = s;
	_t.drawFocus(false);
	
	_t.focus.select(".axis--x").call(_t.xAxis);
	
	_t.svg.select(".zoom").call(_t.zoom.transform, d3.zoomIdentity
			.scale(_t.width / (s[1] - s[0]))
			.translate(-s[0], 0));
	
}


//still broken!!!
Brushchart.prototype.zoomed = function () {
	if (d3.event.sourceEvent && d3.event.sourceEvent.type === "brush") return; // ignore zoom-by-brush
	const transform = d3.event.transform;
	x.domain(transform.rescaleX(_t.x2).domain());
	redrawlines();
	focus.select(".axis--x").call(_t.xAxis);
	this.brushContext = x.range().map(transform.invertX, transform);
	this.context.select(".brush").call(brush.move, brushContext);
}


Brushchart.prototype.update = function (opts) {
	
	this.data = opts.data;
	this.calculateDomain();
	this.drawFocus();
	this.drawContext();
	
	this.updateAxes();
	
	d3.selectAll('.mouse-over-effects').remove();
	this.overlayTooltip();
	
	
}


export default Brushchart;
